import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import {
  setPage,
  setTotal,
  setLimit,
  setColumnVisibility,
  setRoundTableFilters,
  setCurrentRoundConfig,
  setClearRoundTableFilters,
} from '@Modal/reducers/rounds/table/rubberDuckRoundsTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';
import { RubberDuckRoundDto } from '@Modal/reducers/rounds/types';

export const useRubberDuckRoundsTable = () => {
  const dispatch = useDispatch();
  const {
    page,
    limit,
    total,
    selectedFilters,
    columnVisibility,
    roundTableFilters,
    currentRoundConfig,
    columnVisibilityOptions,
  } = useSelector((state: StoreInterface) => state?.rubberDuckRoundTable);

  const roundsListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...roundsListFilters, ...column];
    if (roundsListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = roundsListFilters.filter((col) => col !== column[0]);
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setRoundTableFilters(filter));
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const clearRoundTableFiltersHandler = () => {
    dispatch(setClearRoundTableFilters());
  };

  const handleSetCurrentRoundConfig = (arg: RubberDuckRoundDto) => {
    dispatch(setCurrentRoundConfig(arg));
  };

  return {
    // State
    limit,
    page,
    total,
    selectedFilters,
    columnVisibility,
    roundTableFilters,
    roundsListFilters,
    currentRoundConfig,
    visiblityCustomizable,
    columnVisibilityOptions,
    // Actions
    setPage,
    setLimit,
    setTotal,
    setRoundTableFilters,
    setCurrentRoundConfig,
    setClearRoundTableFilters,
    // Handlers
    handleFilterSelect,
    handleSetCurrentRoundConfig,
    handleApplyColumnVisibility,
    clearRoundTableFiltersHandler,
  };
};
